import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Form, useForm } from '@modernhealth/vital-components';

import type { Dispatch } from 'src/config/rootStore';
import { getUserTimeZone } from 'src/modules/user/selectors/userSelectors';
import { FormInputTimeZone } from 'src/modules/user/components/FormInputTimeZone';

import type { QuestionnaireType } from 'src/modules/pathways/pages/PathwayCreateQuestionnairePage';

import {
    CreatePathwayQuestionnaireLayout,
    QUESTION_LABEL_ID,
} from './CreatePathwayQuestionnaireLayout';

interface Props {
    pathwayUuid: string;
    nextQuestionnaireType?: QuestionnaireType | undefined;
}

export const CreatePathwayQuestionnaireTimezone = ({
    pathwayUuid,
    nextQuestionnaireType,
}: Props) => {
    const dispatch = useDispatch<Dispatch>();
    const { t } = useTranslation();
    const userLocalTimezone = useSelector(getUserTimeZone);

    const form = useForm({
        defaultValues: {
            localTimezone: userLocalTimezone,
        },
    });
    const localTimezone = form.watch('localTimezone');

    return (
        <CreatePathwayQuestionnaireLayout
            pathwayUuid={pathwayUuid}
            question={{
                title: t('pathways:onboarding.questionnaire.timezone.subtitle'),
                description: t('pathways:onboarding.questionnaire.timezone.description'),
            }}
            nextQuestionnaireType={nextQuestionnaireType}
            disabled={!localTimezone}
            onSubmit={() => dispatch.user.updateMemberProfile({ localTimezone })}
        >
            <Form definition={form}>
                <FormInputTimeZone
                    labelledBy={QUESTION_LABEL_ID}
                    name="localTimezone"
                    autoDetectDefaultValue
                />
            </Form>
        </CreatePathwayQuestionnaireLayout>
    );
};
